var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',{staticClass:"card-revisa"},[_c('h2',[_vm._v("Tu contraseña se ha restablecido con éxito")]),_c('p',[_vm._v("Ingresa a tu cuenta con tu nueva contraseña.")]),_c('a',{staticClass:"btn-back-login",attrs:{"href":"/"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-arrow-left")]),_vm._v(" Regresar al inicio de sesión ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }